import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ICardPlain } from './card-plain.interface';

@Component({
    selector: 'mlp-ng-card-plain',
    templateUrl: './card-plain.component.html',
    styleUrls: ['./card-plain.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CardPlainSharedComponent {
    @Input() card: ICardPlain;
}
